exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles_clickableTag__2VYzM>div:first-child:after{content:\"\";position:absolute;width:100%;height:100%;top:0;left:0;background:hsla(0,0%,100%,.25);opacity:0;transition:all .5s;-webkit-transition:all .5s;-moz-transition:all .5s;border-radius:1rem;z-index:0}.styles_clickableTag__2VYzM>div:first-child:hover:after{opacity:1}.styles_clickableTag__2VYzM>div span{z-index:1}", ""]);

// exports
exports.locals = {
	"clickableTag": "styles_clickableTag__2VYzM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Tag/styles.less
// module id = 1685
// module chunks = 8